import { Seo, faqSchema } from "../components/site/Seo";
import { Hero } from "../components/home/Hero";
import { ServicesBento } from "../components/home/ServicesBento";
import { AdasFeature, AssuranceBlock, BlogPreview, CentreSection, DomicilePret, FaqPreview, OptiquesSpotlight } from "../components/home/Features";
import { Marquee } from "../components/site/Marquee";
import { ReviewsSection } from "../components/site/Reviews";
import { LocationSection } from "../components/site/Location";
import { CtaBand } from "../components/site/Cta";
import { FAQ } from "../data/faq";

export default function Home() {
  return (
    <>
      <Seo
        title="Pare-Brise Haguenau – A+ Glass | Vitrage, ADAS, Optiques"
        description="A+GLASS Pare-Brise HAGUENAU : remplacement et réparation de pare-brise, vitrage automobile, calibration caméra ADAS, rénovation d'optiques. 101A Route de Marienthal. 03 88 93 16 73."
        path="/"
        schemas={[faqSchema(FAQ.slice(0, 6))]}
      />
      <Hero />
      <Marquee />
      <ServicesBento />
      <AdasFeature />
      <OptiquesSpotlight />
      <DomicilePret />
      <AssuranceBlock />
      <CentreSection />
      <ReviewsSection />
      <LocationSection />
      <FaqPreview />
      <BlogPreview />
      <CtaBand />
    </>
  );
}
